export default __webpack_public_path__ + "static/media/kitchen3-afterH-480w.01fe027f.avif";